const BASE_API = process.env.MIX_ENDLESS_API_URL
import { flare } from "@flareapp/js";

const state ={
	summerCampsList:[],
	summerCampsListData:[],
	summerCampsMeta:[],
	summerCampsListError:null,
	summerCampsDetail:null,
}
const getters = {
	summerCampsListGetter:({summerCampsList}) => summerCampsList,
	summerCampsMetaGetter:({summerCampsMeta}) => summerCampsMeta,
	summerCampsListData:({summerCampsListData}) => summerCampsListData,
	summerCampsDetailGetter:({summerCampsDetail}) => summerCampsDetail,
}

const mutations = {
	setSummerCampsList: (state,payload)=> {state.summerCampsList = payload},
	setSummerCampsMeta: (state,payload)=> {state.summerCampsMeta = payload},
	setEmptySummerCampsList : (state,payload)=> state.summerCampsListData = [],
	setSummerCampsListSeeMore : (state,payload)=> state.summerCampsListData.push(...payload),
	setSummerCampsDetail: (state,payload)=> {state.summerCampsDetail = payload},
}

const actions = {
	async getSummerCampsList({commit,state}, payload){
		await this.$axios.get(`${BASE_API}/summer-camps-courses`,{params:{...payload.filters},headers:{...payload.headers}}).then(res => {
			commit('setSummerCampsList',res.data.result.data)
			commit('setSummerCampsMeta',res.data.result.meta)
		}).catch(err => {
			if (err.response) {
				state.summerCampsListError = err.response.status;
			} else {
				state.summerCampsListError = 'Unknown error or network issue';
				flare.createReport(err, {
					type: "UnknownError",
					context: "Error on Summer Camps List",
					message: err,
				});
			}
		})
	},
	async getSummerCampsDetail({commit}, payload){
		await this.$axios.get(`${BASE_API}/courses/${payload.courseId}`, {params:{...payload.filters},headers:{...payload.headers}}).then(res => {
			commit('setSummerCampsDetail',res.data.result)
		})
	},
}

export default {namespaced:true,state,getters,mutations,actions}
